export default __webpack_public_path__ + "static/media/BrainlabNowW05-Bold.cc478687.woff";